export const ENDPOINTS = {
  getBills: '/extranet/:hotelId/bills',
} as const;

export const CORE_QUERY_KEYS = {
  bills: 'extranet-bills',
} as const;
